import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NDD: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NDD,
  },
  {
    pageId: PageId.CANCEL_OFFER_NDD,
  },
  {
    pageId: PageId.CHAT_UPSELL_NDD,
  },
  {
    pageId: PageId.UPSELL_NDD,
  },
  {
    pageId: PageId.DOWNLOAD_NDD,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
